//IndexedDb utility functions for glycan visualizer

import {db} from './visdb';

//Adds project to IndexedDB database
export async function addProject(projName, projContent) 
{
    const nameCount = await db.projects
        .where("name").equals(projName)
        .count();

    if (nameCount > 0) {
        throw new Error("A project with this name already exists.");
    }
    await db.projects.add({name:projName, content:projContent});
}

//Saves project to database
export async function saveProject(projName, projContent)
  {
    await db.projects
      .where('name').equals(projName)
      .modify({content: projContent});   
}

//Retrieves project from IndexedDB database.
export async function getProject(projName)
{
    const project = await db.projects
        .where("name").equals(projName)
        .first()
        .then(project => {
            if (project){
                return project.content;
            } else {
                throw new Error("Project not found")
            }
        });
    return project;
}

//Retrieves list of projects from database.
export async function getProjectList()
{
    const projList = await db.projects.toArray();
    return projList;
}

//Deletes project from database.
export async function deleteProject(projName)
  {
    try {
      await db.projects
        .where('name').equals(projName).delete();
    } catch (error){
      console.error("Error")
    }
}